// pd2.js - Patio Door Configuration 2
// Wrapper component that uses the PD template with specific configuration

import React from 'react';
import PD from './pd';
import { pageConfigs } from '../../configs';

const PD2 = () => {
  const controlMapSections = [
    // Add control map sections as they are created
  ];

  return (
    <PD
      config={pageConfigs.pd2}
      controlMapSections={controlMapSections}
      documentType="patiodoors"
      itemPath="patiodoors/pdt/pd2"
    />
  );
};

export default PD2;
